import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase/app'
import variables from '@/custom/variables'
import Store from '@/store'

Vue.use(VueRouter)

// When building apps with a bundler, the JavaScript bundle can become quite large, and thus affect the page load time.
// It would be more efficient if we can split each route's components into a separate chunk, and only load them when the route is visited.
// The loadView function makes use of Vue's async component feature and webpack's code splitting to achieve this.
// More information: https://router.vuejs.org/guide/advanced/lazy-loading.html

// There is a case of pop-in when lazy loading the routes, it needs to be fixed

function loadView (folder, view) {
  return () => import(/* webpackChunkName: "[request]" */ `@/${folder}/${view}.vue`)
}

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes: [{
    path: '/login',
    name: 'Login',
    component: loadView('views/common', 'Login')
  },
  {
    path: '/tos',
    name: 'Tos',
    component: loadView('views/common', 'Tos')
  },
  {
    path: '/policy',
    name: 'Policy',
    component: loadView('views/common', 'Policy')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: loadView('views/common', 'Dashboard'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/referral-dashboard',
    name: 'ReferralsDashboard',
    component: loadView('views/referrer', 'ReferralsDashboard'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/referrals',
    name: 'Referrals',
    component: loadView('views/referrer', 'Referrals'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/hefe/job-details/:jobId',
    name: 'HefeJobDetails',
    component: loadView('views/jefe', 'HefeJobDetails'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/obrero/job-details/:jobId',
    name: 'ObrJobDetails',
    component: loadView('views/obrero', 'ObrJobDetails'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/public/job-details/:jobId',
    name: 'PublicJobDetails',
    component: loadView('views/public', 'PublicJobDetails'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/obrero/earnings',
    name: 'Earnings',
    component: loadView('views/obrero', 'Earnings'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/hefes',
    name: 'Hefes',
    component: loadView('components', 'Hefes'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/contract',
    name: 'Contract',
    component: loadView('components', 'Contract'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registration',
    name: 'Registration',
    component: loadView('views/common', 'Registration'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stripe-registration',
    name: 'StripeRegistration',
    component: loadView('views/common', 'StripeRegistration'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/hefe/favorites',
    name: 'HefeFavorites',
    component: loadView('views/jefe', 'Favorites'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/obrero/job-search',
    name: 'ObrJobSearch',
    component: loadView('views/obrero', 'JobSearch'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/hefe/payments',
    name: 'Payments',
    component: loadView('views/jefe', 'Payments'),
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/translation',
    name: 'Translation',
    component: loadView('views/common', 'Translation'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/public/campaign',
    name: 'CampaignRegistration',
    component: loadView('views/public', 'CampaignRegistration'),
    meta: {
      requiresAuth: false
    }
  }, {
    path: '/public/job-search',
    name: 'PublicJobSearch',
    component: loadView('views/public', 'PublicJobSearch'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '*',
    redirect: '/login'
  }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser || false
  const currentLanguage = Store.getters['getLanguage'] || 'en'
  Vue.prototype.$language = variables.data[currentLanguage]

  if (requiresAuth && !currentUser && to.name !== 'PublicJobSearch' && to.name !== 'PublicJobDetails') {
    next({
      path: '/login'
    })
  } else {
    next(true)
  }
})

export default router
